import { ToneDto, ToneDtoImpl } from '../tonedto';
import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';
import { BaseContext } from '../../../utils/basecontext';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';

export class BannerSearchBuilder
{
    constructor(private bannerSearchList: any, private context: BaseContext)
    {
        if(bannerSearchList.searchList === undefined)
        {
            throw new NoDataException("Banner Search data doesnt exists");
        }
    }

    buildAll(): ToneDto[]
    {
        return this.parseBannerSearchDetailsResponse();
    }
    
    private parseBannerSearchDetailsResponse(): ToneDto[]
    {
        let listOfSearchBanners: ToneDto[] = [];
        
        let bannerSearchDetailsResponse = null;
        this.bannerSearchList.searchList.forEach((bannerSearchJson: any, index: number) =>
        {
            bannerSearchDetailsResponse = new ToneDtoImpl();
            bannerSearchDetailsResponse.setId(bannerSearchJson.toneId);
            bannerSearchDetailsResponse.setToneName(bannerSearchJson.toneName);
            bannerSearchDetailsResponse.setImgPath(bannerSearchJson.toneIdpreviewImageUrl);
            bannerSearchDetailsResponse.setToneUrl(bannerSearchJson.toneIdStreamingUrl);
            bannerSearchDetailsResponse.setArtistName(bannerSearchJson.artistName);
            bannerSearchDetailsResponse.setAlbumName(bannerSearchJson.album);
            bannerSearchDetailsResponse.setCategoryId(bannerSearchJson.categoryId);
            bannerSearchDetailsResponse.setExpirydate(DateFormat.formatExpiryDate(bannerSearchJson.expiryDate, this.context));
            // bannerSearchDetailsResponse.setContentProviderName(bannerSearchJson.contentProviderName);
            
            listOfSearchBanners.push(bannerSearchDetailsResponse);
        });
        return listOfSearchBanners;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/bannersearch/bannersearchbuilder.ts